import bannerCount, {
  safeParams as bannerCountSafeParams,
} from 'src/internal/platformMetrics/trackers/bannerCount';
import orgGlobalsAreaCount, {
  safeParams as orgGlobalsAreaCountSafeParams,
} from 'src/internal/platformMetrics/trackers/orgGlobalsAreaCount';
import {
  translationCount,
  safeParams as translationSafeParams,
} from 'src/internal/platformMetrics/trackers/translationCount';
import {
  translationCountForMessageLength,
  safeParams as translationwithWeightSafeParams,
} from 'src/internal/platformMetrics/trackers/translationCountForMessageLength';

import type {AbstractTracker} from 'src/internal/platformMetrics/aggregators/AbstractTracker';

export const trackers = {
  bannerCount,
  orgGlobalsAreaCount,
  translationCount,
  translationCountForMessageLength,
};

export const enabledTrackers: ReadonlyArray<
  AbstractTracker<Record<string, unknown>>
> = [
  bannerCount,
  orgGlobalsAreaCount,
  translationCount,
  translationCountForMessageLength,
];

export const trackersSafeParams = [
  ...bannerCountSafeParams,
  ...orgGlobalsAreaCountSafeParams,
  ...translationSafeParams,
  ...translationwithWeightSafeParams,
] as const;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function throwsIfNotMocked() {
  throw new Error(
    "To properly assert tracking logic, make sure you call `jest.mock('src/observability/internal/platformMetrics/trackers')` within your test",
  );
}
